import { useMemo } from 'react'
import { getHeyImmoExperimentState } from '../../../utils/features/heyImmoExperiment'

export function useHeyImmoExperimentTracking() {
  return useMemo(() => getHeyImmoExperimentState().trackingParameters, [])
}
